export default function TrustSignals() {
  const signals = [
    {
      icon: 'ri-car-line',
      number: '50,000+',
      label: 'Vehicles Shipped'
    },
    {
      icon: 'ri-star-fill',
      number: '4.9/5',
      label: 'Star Rating',
      extra: '(2,847 reviews)'
    },
    {
      icon: 'ri-shield-check-line',
      number: 'USDOT',
      label: 'Licensed Carrier'
    },
    {
      icon: 'ri-checkbox-circle-line',
      number: '$0',
      label: 'Upfront Payment'
    },
    {
      icon: 'ri-customer-service-2-line',
      number: '24/7',
      label: 'Customer Support'
    }
  ];

  return (
    <section className="py-16 bg-white border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {signals.map((signal, index) => (
            <div key={index} className="text-center">
              <i className={`${signal.icon} text-4xl text-orange-600 mb-3`}></i>
              <div className="text-3xl font-bold text-gray-900 mb-1">
                {signal.number}
              </div>
              <div className="text-sm font-medium text-gray-600">
                {signal.label}
              </div>
              {signal.extra && (
                <div className="text-xs text-gray-500 mt-1">
                  {signal.extra}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
